



















import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({})
export default class CloseButtonBlackSvg extends Vue {
  @Prop({ default: 'close' }) private readonly testId: string | undefined;
}
